import { LoadablePaint } from '@confluence/loadable';

const AI_PLANNER_BRIDGE_NAVIGATION_PARAMS = {
	Screen: {
		showPremiumOnboarding: false,
		screenEvent: {
			name: 'aiPlannerConfluenceBridgeScreen',
		},
	},
	MainLayout: false,
	BannerContext: { includeTopNav: false },
};

export const AIPlannerConfluenceBridgeRoute = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AIPlannerConfluenceBridgeRoute" */ '@confluence/ai-planner-confluence-bridge-route/entry-points/AIPlannerConfluenceBridgeRoute.ts'
			)
		).AIPlannerConfluenceBridgeRoute,
});

AIPlannerConfluenceBridgeRoute.NAVIGATION_PARAMS = () => AI_PLANNER_BRIDGE_NAVIGATION_PARAMS;
